import { render, staticRenderFns } from "./tbzbhxr.vue?vue&type=template&id=20b18de1&"
import script from "./tbzbhxr.vue?vue&type=script&lang=js&"
export * from "./tbzbhxr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports